<ng-template #ngIfModalBody>
  <div id="modal">
    <div
      nxModalContent
      class="nx-margin-bottom-m">
      <div class="headline nx-margin-bottom-2xs">
        @if (textContent?.icon) {
          <nx-icon
            class="nx-margin-right-xs"
            [name]="textContent?.icon"
            size="s"></nx-icon>
        }
        @if (textContent?.headline) {
          <h4
            data-cy="modal-headline"
            [innerHTML]="textContent?.headline | text"></h4>
        }
      </div>
      @if (textContent?.subheadline) {
        <p
          nxCopytext="normal"
          class="u-text-weight-bold nx-margin-bottom-2xs"
          data-cy="modal-subheadline"
          [innerHTML]="textContent?.subheadline | text"></p>
      }
      @if (textContent?.body) {
        <p
          nxCopytext="normal"
          [ngClass]="'modal-content'"
          data-cy="modal-content"
          [innerHTML]="textContent?.body | text: textContent?.bodyParams"></p>
      }
      @if (textContent?.userConfirmationCheckbox) {
        <nx-checkbox
          [checked]="userConfirmationCheckboxValue"
          (checkedChange)="userConfirmationValueChanged()"
          data-cy="modal-user-confirmation-checkbox"
          class="nx-margin-bottom-4m">
          {{ textContent?.userConfirmationCheckbox }}
        </nx-checkbox>
      }
    </div>
    <div nxModalActions>
      @if (textContent?.secondaryButton) {
        <button
          class="nx-margin-bottom-0 nx-margin-right-xs"
          nxButton="{{ styleObject.secondaryButtonType || 'secondary small' }}"
          data-cy="modal-secondary-button"
          (click)="buttonClick(modalButtonTypes.SECONDARY)">
          {{ textContent?.secondaryButton }}
        </button>
      }
      @if (textContent?.button) {
        <button
          [disabled]="textContent?.userConfirmationCheckbox && !userConfirmationCheckboxValue"
          class="nx-margin-bottom-0"
          nxButton="{{ styleObject.primaryButtonType || 'primary small' }}"
          data-cy="modal-primary-button"
          (click)="buttonClick(modalButtonTypes.PRIMARY)">
          {{ textContent?.button }}
        </button>
      }
    </div>
  </div>
</ng-template>
